```vue
<template>
  <div class="cbt-page" v-if="state.loaded">

    <!-- HEADER -->
    <header class="header">
      <div>
        <h1>{{subject}} Examination</h1>
        <p>Answer all questions</p>
      </div>

      <div class="timer-box">
        ⏱ {{ formattedTime }}
      </div>
    </header>

    <!-- QUESTION AREA -->
    <main class="question-container">

      <!-- QUESTION INFO -->
      <div class="question-top">
        <span class="question-badge">
          Question {{question.num }}
        </span>

        <span class="question-type">
          {{ question.type =="1" ? "OBJECTIVE" : "SUBJECTIVE" }}
        </span>
      </div>

      <!-- QUESTION TEXT -->
      <div class="question-text" v-html="question.q"></div>

      <!-- OBJECTIVE -->
      <div v-if="question.type === '1'" class="options-container">

        <label class="option-card">
            <span class="opt">(A) </span>

          <input
            type="radio"
            name="opt"
            value="A"
            v-model="answer"
          />

          <span> {{ question.a }}</span>
        </label>
        <label class="option-card">

        <span class="opt">(B) </span>
          <input
            type="radio"
            name="opt"
            value="B"
            v-model="answer"
          />

          <span> {{ question.b }}</span>
        </label>
        <label class="option-card">

        <span class="opt">(C) </span>
          <input
            type="radio"
            name="opt"
            value="C"
            v-model="answer"
          />

          <span>{{ question.c }}</span>
        </label>
        <label class="option-card">
            
        <span class="opt">(D) </span>
          <input
            type="radio"
            name="opt"
            value="D"
            v-model="answer"
          />

          <span> {{ question.d }}</span>
        </label>
      </div>

      <!-- SUBJECTIVE -->
      <div v-else class="subjective-box">
        <EditorView
          v-model="answer"
          placeholder="Write your answer here..."
        />
      </div>

    </main>

    <!-- BOTTOM NAVIGATION -->
    <footer class="bottom-section">

      <!-- QUESTION NUMBERS -->
      <div class="question-nav">
        <button
          v-for="(q, index) in ques_list"
          :key="index"
          @click="goToQuestion(q.id)"
          :class="[
            'nav-btn',
            qid === q.id ? 'active' : '',
            answers[q.id] ? 'answered' : ''
          ]"
        >
          {{ q.num}}
        </button>
      </div>

      <!-- ACTION BUTTONS -->
      <div class="action-buttons">

        <button
          class="secondary-btn"
          @click="previousQuestion"
          :disabled="currentQuestionIndex == 1"
        >
          ← Previous
        </button>

        <button
          class="secondary-btn"
          @click="nextQuestion"
          :disabled="currentQuestionIndex === questions.length - 1"
        >
          Next →
        </button>

        <button class="submit-btn" @click="endExam">
          End Test
        </button>

      </div>

    </footer>

  </div>
  <div v-else class="loader" style="align-items: center; flex-direction: column;">
    <div class="submit" v-if='state.submitting' style="padding:10px; font-weight:bold">
        Submitting
    </div>
    <img src="@/assets/img/ajldr.gif" style="display:block"/>
  </div>
</template>

<script setup>
    import call from "../composables/call.js";
    import { urls } from "../assets/js/urls.js";
    import { ref, computed, onMounted, onUnmounted, reactive } from "vue"
    import {  useRoute } from "vue-router";
    
import EditorView from '@/components/EditorView.vue'

    const state=reactive({loaded:false,submitting:false})
    // const router=useRouter();
    const subject=ref("")
    const route=useRoute();
    const group=computed(() =>route.params.group)
    const id=computed(() =>route.params.id)
    const ques_list=ref([])
    const question=ref([])
    const answer=ref("")
    const qid=ref("")

    const questions = ref([
    {
        id: 1,
        type: "objective",
        question: "What is the capital of France?",
        options: ["Berlin", "Madrid", "Paris", "Rome"]
    },

    {
        id: 2,
        type: "subjective",
        question:
        "Explain the importance of education in national development."
    },

    {
        id: 3,
        type: "objective",
        question: "Which planet is known as the Red Planet?",
        options: ["Earth", "Mars", "Venus", "Jupiter"]
    },

    {
        id: 4,
        type: "subjective",
        question:
        "Describe your favorite hobby and why you enjoy it."
    }
    ])

    /*
    |--------------------------------------------------------------------------
    | CURRENT QUESTION
    |--------------------------------------------------------------------------
    */

    const currentQuestionIndex = ref(0)

    /*
    |--------------------------------------------------------------------------
    | ANSWERS
    |--------------------------------------------------------------------------
    */

    const answers = ref({})

    /*
    |--------------------------------------------------------------------------
    | NAVIGATION
    |--------------------------------------------------------------------------
    */

    const nextQuestion = () => {
        getQuestion("next")
    }

    const previousQuestion = () => {
        getQuestion("prev")
    }

    const goToQuestion = (index) => {
        getQuestion(index)
    }

    function getQuestion(nqid){
        state.loaded=false
        call({
            url:urls.test,
            data:{getQuestion:id.value,group:group.value,qid:qid.value, answer:answer.value, next:nqid},
            success:(res)=>{
                state.loaded=true
                if(res.status){
                    state.loaded=true
                    subject.value=res.msg.subject;
                    ques_list.value.length=0
                    Object.keys(res.msg.questions).forEach(k => {
                        ques_list.value.push(res.msg.questions[k])
                    })
                    answer.value=res.msg.question.ans;
                    Object.keys(res.msg.question).forEach(k => {
                        question.value[k]=res.msg.question[k]
                    })
                    qid.value=res.msg.qid;
                    const endTime = new Date(res.msg.endtime);

                    // User local time
                    console.log("Local End Time:", endTime.toString());

                    // Current local time
                    const now = new Date();

                    // Difference in milliseconds
                    const diffMs = endTime - now;

                    // Convert to minutes
                    const minsLeft = Math.max(0, Math.floor(diffMs / 1000 / 60));

                    console.log(minsLeft + " mins left");

                    if (minsLeft <= 0) {
                        console.log("Expired");
                    }
                    timeLeft.value=minsLeft*60;
                    currentQuestionIndex.value=res.msg.question.num;
                }else{
                    alert(res.msg);
                }
            }
        })
    }

    function endExam(){
        var ask=confirm("Are you sure you want to end this test now?")
        if(ask){
            submit()
        }
    }

    function submit(){
        state.loaded=false
        state.submitting=true;
        call({
            url:urls.test,
            data:{getQuestion:id.value,group:group.value,qid:qid.value, answer:answer.value,end:true},
            success:(res)=>{
                state.submitting=false;
                if(res.status){
                    alert(res.msg)
                }else{
                    alert(res.msg);
                }
            }
        })
    }

    /*
    |--------------------------------------------------------------------------
    | TIMER
    |--------------------------------------------------------------------------
    */

    const timeLeft = ref(60 * 60)

    let timer = null

    onMounted(() => {
        call({
            url:urls.test,
            data:{writeTest:id.value,group:group.value},
            success:(res)=>{
                if(res.status){
                    state.loaded=true
                    subject.value=res.msg.subject;
                    ques_list.value.length=0
                    Object.keys(res.msg.questions).forEach(k => {
                        ques_list.value.push(res.msg.questions[k])
                    })
                    answer.value=res.msg.question.ans;
                    console.log(answer.value)
                    Object.keys(res.msg.question).forEach(k => {
                        question.value[k]=res.msg.question[k]
                    })
                    qid.value=res.msg.qid;
                    const endTime = new Date(res.msg.endtime);

                    // User local time
                    console.log("Local End Time:", endTime.toString());

                    // Current local time
                    const now = new Date();

                    // Difference in milliseconds
                    const diffMs = endTime - now;

                    // Convert to minutes
                    const minsLeft = Math.max(0, Math.floor(diffMs / 1000 / 60));

                    console.log(minsLeft + " mins left");

                    if (minsLeft <= 0) {
                        console.log("Expired");
                    }
                    timeLeft.value=minsLeft*60;
                    currentQuestionIndex.value=res.msg.question.num;
                }else{
                    alert(res.msg);
                }
            }
        })
        timer = setInterval(() => {
            if (timeLeft.value > 0) {
            timeLeft.value--
            }else{
                clearInterval(timer)
                submit()
            }
        }, 1000)
    })

    onUnmounted(() => {
        clearInterval(timer)
    })

    const formattedTime = computed(() => {
    const hours = Math.floor(timeLeft.value / 3600)
    const minutes = Math.floor((timeLeft.value % 3600) / 60)
    const seconds = timeLeft.value % 60

    return `${String(hours).padStart(2, "0")}:${String(
        minutes
    ).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`
    })
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: Arial, sans-serif;
}

.cbt-page {
  min-height: 100vh;
  background: #f4f7fb;
  padding: 20px;

  display: flex;
  flex-direction: column;
}

/* HEADER */

.header {
  background: white;
  padding: 20px;
  border-radius: 18px;

  display: flex;
  justify-content: space-between;
  align-items: center;

  margin-bottom: 20px;

  box-shadow: 0 5px 20px rgba(0,0,0,0.05);
}

.header h1 {
  font-size: 28px;
}

.header p {
  margin-top: 5px;
  color: #666;
}

.timer-box {
  background: #111827;
  color: white;

  padding: 14px 18px;
  border-radius: 12px;

  font-size: 18px;
  font-weight: bold;
}

/* QUESTION AREA */

.question-container {
  flex: 1;
  background: white;
  border-radius: 20px;
  padding: 30px;
  box-shadow: 0 5px 20px rgba(0,0,0,0.05);
  width:min(700px,100%)
}

.question-top {
  display: flex;
  justify-content: space-between;
  align-items: center;

  margin-bottom: 25px;
}

.question-badge {
  background: #4f46e5;
  color: white;

  padding: 10px 16px;
  border-radius: 10px;

  font-weight: bold;
}

.question-type {
  color: #666;
  font-weight: bold;
}

.question-text {
  font-size: 24px;
  line-height: 1.6;

  margin-bottom: 30px;
}

/* OPTIONS */

.options-container {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.option-card {
  border: 2px solid #e5e7eb;
  border-radius: 14px;

  padding: 18px;

  display: flex;
  align-items: center;
  gap: 12px;

  cursor: pointer;
  transition: 0.2s;
}

.option-card:hover {
  border-color: #4f46e5;
  background: #eef2ff;
}

.option-card input {
  transform: scale(1.2);
}

/* SUBJECTIVE */

.subjective-box textarea {
  width: 100%;
  min-height: 250px;

  border: 2px solid #d1d5db;
  border-radius: 14px;

  padding: 20px;

  font-size: 16px;
  resize: vertical;

  outline: none;
}

.subjective-box textarea:focus {
  border-color: #4f46e5;
}

/* BOTTOM SECTION */

.bottom-section {
  margin-top: 20px;

  background: white;
  border-radius: 18px;

  padding: 20px;

  box-shadow: 0 5px 20px rgba(0,0,0,0.05);
}

/* QUESTION NAV */

.question-nav {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;

  margin-bottom: 20px;
}

.nav-btn {
  width: 48px;
  height: 48px;

  border: none;
  border-radius: 12px;

  background: #e5e7eb;

  cursor: pointer;
  font-weight: bold;

  transition: 0.2s;
}

.nav-btn.active {
  background: #4f46e5;
  color: white;
}

.nav-btn.answered {
  border: 3px solid #10b981;
}

/* ACTIONS */

.action-buttons {
  display: flex;
  gap: 15px;
}

.secondary-btn,
.submit-btn {
  flex: 1;

  padding: 15px;

  border: none;
  border-radius: 12px;

  font-size: 16px;
  font-weight: bold;

  cursor: pointer;
}

.secondary-btn {
  background: #111827;
  color: white;
}

.secondary-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.submit-btn {
  background: #ef4444;
  color: white;
}
.opt{font-weight:bold}

/* MOBILE */

@media (max-width: 768px) {

  .header {
    flex-direction: column;
    gap: 15px;
    align-items: flex-start;
  }

  .question-text {
    font-size: 20px;
  }

  .action-buttons {
    flex-direction: column;
  }

  .question-nav {
    justify-content: center;
  }

  .nav-btn {
    width: 42px;
    height: 42px;
  }
}
</style>